import { render, staticRenderFns } from "./recipeItemTable.vue?vue&type=template&id=1de852a9&"
import script from "./recipeItemTable.vue?vue&type=script&lang=ts&"
export * from "./recipeItemTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports